export default __webpack_public_path__ + "static/media/starting-package.e53817b9.png";